import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Search, ChevronDown, X } from 'lucide-react';
import { TradingMode } from '../App';

interface SearchablePairSelectorProps {
  selectedPair: string;
  onPairSelect: (pair: string) => void;
  tradingMode: 'spot' | 'futures' | 'cfd' | 'binary' | 'robot' | 'wallet' | 'events';
  marketDataList?: any[]; // Not used anymore as we're using predefined pairs
}

// Predefined list of top 150 crypto pairs
const TOP_CRYPTO_PAIRS = [
  { symbol: 'BTCUSDT', name: 'BTC/USDT', type: 'crypto', active: true },
  { symbol: 'ETHUSDT', name: 'ETH/USDT', type: 'crypto', active: true },
  { symbol: 'SOLUSDT', name: 'SOL/USDT', type: 'crypto', active: true },
  { symbol: 'XRPUSDT', name: 'XRP/USDT', type: 'crypto', active: true },
  { symbol: 'BNBUSDT', name: 'BNB/USDT', type: 'crypto', active: true },
  { symbol: 'DOGEUSDT', name: 'DOGE/USDT', type: 'crypto', active: true },
  { symbol: 'ADAUSDT', name: 'ADA/USDT', type: 'crypto', active: true },
  { symbol: 'AVAXUSDT', name: 'AVAX/USDT', type: 'crypto', active: true },
  { symbol: 'DOTUSDT', name: 'DOT/USDT', type: 'crypto', active: true },
  { symbol: 'MATICUSDT', name: 'MATIC/USDT', type: 'crypto', active: true },
  { symbol: 'LINKUSDT', name: 'LINK/USDT', type: 'crypto', active: true },
  { symbol: 'LTCUSDT', name: 'LTC/USDT', type: 'crypto', active: true },
  { symbol: 'UNIUSDT', name: 'UNI/USDT', type: 'crypto', active: true },
  { symbol: 'SHIBUSDT', name: 'SHIB/USDT', type: 'crypto', active: true },
  { symbol: 'ATOMUSDT', name: 'ATOM/USDT', type: 'crypto', active: true },
  { symbol: 'ETCUSDT', name: 'ETC/USDT', type: 'crypto', active: true },
  { symbol: 'TRXUSDT', name: 'TRX/USDT', type: 'crypto', active: true },
  { symbol: 'NEARUSDT', name: 'NEAR/USDT', type: 'crypto', active: true },
  { symbol: 'APTUSDT', name: 'APT/USDT', type: 'crypto', active: true },
  { symbol: 'FILUSDT', name: 'FIL/USDT', type: 'crypto', active: true },
  { symbol: 'AAVEUSDT', name: 'AAVE/USDT', type: 'crypto', active: true },
  { symbol: 'ALGOUSDT', name: 'ALGO/USDT', type: 'crypto', active: true },
  { symbol: 'AXSUSDT', name: 'AXS/USDT', type: 'crypto', active: true },
  { symbol: 'BCHUSDT', name: 'BCH/USDT', type: 'crypto', active: true },
  { symbol: 'COMPUSDT', name: 'COMP/USDT', type: 'crypto', active: true },
  { symbol: 'DASHUSDT', name: 'DASH/USDT', type: 'crypto', active: true },
  { symbol: 'EOSUSDT', name: 'EOS/USDT', type: 'crypto', active: true },
  { symbol: 'ICPUSDT', name: 'ICP/USDT', type: 'crypto', active: true },
  { symbol: 'MKRUSDT', name: 'MKR/USDT', type: 'crypto', active: true },
  { symbol: 'NEOUSDT', name: 'NEO/USDT', type: 'crypto', active: true },
  { symbol: 'SNXUSDT', name: 'SNX/USDT', type: 'crypto', active: true },
  { symbol: 'VETUSDT', name: 'VET/USDT', type: 'crypto', active: true },
  { symbol: 'XLMUSDT', name: 'XLM/USDT', type: 'crypto', active: true },
  { symbol: 'XMRUSDT', name: 'XMR/USDT', type: 'crypto', active: true },
  { symbol: 'XTZUSDT', name: 'XTZ/USDT', type: 'crypto', active: true },
  { symbol: 'ZECUSDT', name: 'ZEC/USDT', type: 'crypto', active: true },
  { symbol: 'ZILUSDT', name: 'ZIL/USDT', type: 'crypto', active: true },
  { symbol: '1INCHUSDT', name: '1INCH/USDT', type: 'crypto', active: true },
  { symbol: 'ARUSDT', name: 'AR/USDT', type: 'crypto', active: true },
  { symbol: 'BATUSDT', name: 'BAT/USDT', type: 'crypto', active: true },
  { symbol: 'CRVUSDT', name: 'CRV/USDT', type: 'crypto', active: true },
  { symbol: 'ENJUSDT', name: 'ENJ/USDT', type: 'crypto', active: true },
  { symbol: 'FTMUSDT', name: 'FTM/USDT', type: 'crypto', active: true },
  { symbol: 'GRTUSDT', name: 'GRT/USDT', type: 'crypto', active: true },
  { symbol: 'HBARUSDT', name: 'HBAR/USDT', type: 'crypto', active: true },
  { symbol: 'HOTUSDT', name: 'HOT/USDT', type: 'crypto', active: true },
  { symbol: 'IOTAUSDT', name: 'IOTA/USDT', type: 'crypto', active: true },
  { symbol: 'KAVAUSDT', name: 'KAVA/USDT', type: 'crypto', active: true },
  { symbol: 'KNCUSDT', name: 'KNC/USDT', type: 'crypto', active: true },
  { symbol: 'KSMUSDT', name: 'KSM/USDT', type: 'crypto', active: true },
  { symbol: 'LRCUSDT', name: 'LRC/USDT', type: 'crypto', active: true },
  { symbol: 'MANAUSDT', name: 'MANA/USDT', type: 'crypto', active: true },
  { symbol: 'OMGUSDT', name: 'OMG/USDT', type: 'crypto', active: true },
  { symbol: 'ONTUSDT', name: 'ONT/USDT', type: 'crypto', active: true },
  { symbol: 'QTUMUSDT', name: 'QTUM/USDT', type: 'crypto', active: true },
  { symbol: 'RENUSDT', name: 'REN/USDT', type: 'crypto', active: true },
  { symbol: 'RVNUSDT', name: 'RVN/USDT', type: 'crypto', active: true },
  { symbol: 'SANDUSDT', name: 'SAND/USDT', type: 'crypto', active: true },
  { symbol: 'STORJUSDT', name: 'STORJ/USDT', type: 'crypto', active: true },
  { symbol: 'SUSHIUSDT', name: 'SUSHI/USDT', type: 'crypto', active: true },
  { symbol: 'THETAUSDT', name: 'THETA/USDT', type: 'crypto', active: true },
  { symbol: 'WAVESUSDT', name: 'WAVES/USDT', type: 'crypto', active: true },
  { symbol: 'YFIUSDT', name: 'YFI/USDT', type: 'crypto', active: true },
  { symbol: 'ZRXUSDT', name: 'ZRX/USDT', type: 'crypto', active: true },
  { symbol: 'ANKRUSDT', name: 'ANKR/USDT', type: 'crypto', active: true },
  { symbol: 'BANDUSDT', name: 'BAND/USDT', type: 'crypto', active: true },
  { symbol: 'BELUSDT', name: 'BEL/USDT', type: 'crypto', active: true },
  { symbol: 'BLZUSDT', name: 'BLZ/USDT', type: 'crypto', active: true },
  { symbol: 'CHRUSDT', name: 'CHR/USDT', type: 'crypto', active: true },
  { symbol: 'CHZUSDT', name: 'CHZ/USDT', type: 'crypto', active: true },
  { symbol: 'CKBUSDT', name: 'CKB/USDT', type: 'crypto', active: true },
  { symbol: 'COTIUSDT', name: 'COTI/USDT', type: 'crypto', active: true },
  { symbol: 'CVCUSDT', name: 'CVC/USDT', type: 'crypto', active: true },
  { symbol: 'DENTUSDT', name: 'DENT/USDT', type: 'crypto', active: true },
  { symbol: 'DGBUSDT', name: 'DGB/USDT', type: 'crypto', active: true },
  { symbol: 'DODOUSDT', name: 'DODO/USDT', type: 'crypto', active: true },
  { symbol: 'FETUSDT', name: 'FET/USDT', type: 'crypto', active: true },
  { symbol: 'FLMUSDT', name: 'FLM/USDT', type: 'crypto', active: true },
  { symbol: 'FLOWUSDT', name: 'FLOW/USDT', type: 'crypto', active: true },
  { symbol: 'GALAUSDT', name: 'GALA/USDT', type: 'crypto', active: true },
  { symbol: 'GTCUSDT', name: 'GTC/USDT', type: 'crypto', active: true },
  { symbol: 'ICXUSDT', name: 'ICX/USDT', type: 'crypto', active: true },
  { symbol: 'IOSTUSDT', name: 'IOST/USDT', type: 'crypto', active: true },
  { symbol: 'KLAYUSDT', name: 'KLAY/USDT', type: 'crypto', active: true },
  { symbol: 'MASKUSDT', name: 'MASK/USDT', type: 'crypto', active: true },
  { symbol: 'MTLUSDT', name: 'MTL/USDT', type: 'crypto', active: true },
  { symbol: 'NKNUSDT', name: 'NKN/USDT', type: 'crypto', active: true },
  { symbol: 'OCEANUSDT', name: 'OCEAN/USDT', type: 'crypto', active: true },
  { symbol: 'ONEUSDT', name: 'ONE/USDT', type: 'crypto', active: true },
  { symbol: 'PERPUSDT', name: 'PERP/USDT', type: 'crypto', active: true },
  { symbol: 'REEFUSDT', name: 'REEF/USDT', type: 'crypto', active: true },
  { symbol: 'RSRUSDT', name: 'RSR/USDT', type: 'crypto', active: true },
  { symbol: 'RUNEUSDT', name: 'RUNE/USDT', type: 'crypto', active: true },
  { symbol: 'SKLUSDT', name: 'SKL/USDT', type: 'crypto', active: true },
  { symbol: 'SRMUSDT', name: 'SRM/USDT', type: 'crypto', active: true },
  { symbol: 'STMXUSDT', name: 'STMX/USDT', type: 'crypto', active: true },
  { symbol: 'TOMOUSDT', name: 'TOMO/USDT', type: 'crypto', active: true },
  { symbol: 'TRBUSDT', name: 'TRB/USDT', type: 'crypto', active: true },
  { symbol: 'ZENUSDT', name: 'ZEN/USDT', type: 'crypto', active: true },
  { symbol: 'ALPHAUSDT', name: 'ALPHA/USDT', type: 'crypto', active: true },
  { symbol: 'AUDIOUSDT', name: 'AUDIO/USDT', type: 'crypto', active: true },
  { symbol: 'BAKEUSDT', name: 'BAKE/USDT', type: 'crypto', active: true },
  { symbol: 'BALUSDT', name: 'BAL/USDT', type: 'crypto', active: true },
  { symbol: 'BTCDOMUSDT', name: 'BTCDOM/USDT', type: 'crypto', active: true },
  { symbol: 'C98USDT', name: 'C98/USDT', type: 'crypto', active: true },
  { symbol: 'CELOUSDT', name: 'CELO/USDT', type: 'crypto', active: true },
  { symbol: 'CELRUSDT', name: 'CELR/USDT', type: 'crypto', active: true },
  { symbol: 'CFXUSDT', name: 'CFX/USDT', type: 'crypto', active: true },
  { symbol: 'CTKUSDT', name: 'CTK/USDT', type: 'crypto', active: true },
  { symbol: 'DARUSDT', name: 'DAR/USDT', type: 'crypto', active: true },
  { symbol: 'DUSKUSDT', name: 'DUSK/USDT', type: 'crypto', active: true },
  { symbol: 'ENSUSDT', name: 'ENS/USDT', type: 'crypto', active: true },
  { symbol: 'GALUSDT', name: 'GAL/USDT', type: 'crypto', active: true },
  { symbol: 'GMTUSDT', name: 'GMT/USDT', type: 'crypto', active: true },
  { symbol: 'IMXUSDT', name: 'IMX/USDT', type: 'crypto', active: true },
  { symbol: 'JASMYUSDT', name: 'JASMY/USDT', type: 'crypto', active: true },
  { symbol: 'LPTUSDT', name: 'LPT/USDT', type: 'crypto', active: true },
  { symbol: 'LQTYUSDT', name: 'LQTY/USDT', type: 'crypto', active: true },
  { symbol: 'LUNA2USDT', name: 'LUNA2/USDT', type: 'crypto', active: true },
  { symbol: 'MINAUSDT', name: 'MINA/USDT', type: 'crypto', active: true },
  { symbol: 'OPUSDT', name: 'OP/USDT', type: 'crypto', active: true },
  { symbol: 'PEOPLEUSDT', name: 'PEOPLE/USDT', type: 'crypto', active: true },
  { symbol: 'RNDRUSDT', name: 'RNDR/USDT', type: 'crypto', active: true },
  { symbol: 'STGUSDT', name: 'STG/USDT', type: 'crypto', active: true },
  { symbol: 'SUIUSDT', name: 'SUI/USDT', type: 'crypto', active: true },
  { symbol: 'TUSDT', name: 'T/USDT', type: 'crypto', active: true },
  { symbol: 'WOOUSDT', name: 'WOO/USDT', type: 'crypto', active: true },
  { symbol: 'XEMUSDT', name: 'XEM/USDT', type: 'crypto', active: true }
];

// Predefined list of CFD instruments - ONLY SHOW THESE SPECIFIC INSTRUMENTS
const CFD_INSTRUMENTS = [
  // Forex pairs - Raw format without slashes
  { symbol: 'EURUSD', name: 'EUR/USD', type: 'forex', active: true },
  { symbol: 'GBPUSD', name: 'GBP/USD', type: 'forex', active: true },
  { symbol: 'USDJPY', name: 'USD/JPY', type: 'forex', active: true },
  { symbol: 'USDCHF', name: 'USD/CHF', type: 'forex', active: true },
  { symbol: 'AUDUSD', name: 'AUD/USD', type: 'forex', active: true },
  { symbol: 'USDCAD', name: 'USD/CAD', type: 'forex', active: true },
  { symbol: 'NZDUSD', name: 'NZD/USD', type: 'forex', active: true },
  { symbol: 'EURJPY', name: 'EUR/JPY', type: 'forex', active: true },
  { symbol: 'GBPJPY', name: 'GBP/JPY', type: 'forex', active: true },
  { symbol: 'EURGBP', name: 'EUR/GBP', type: 'forex', active: true },
  
  // Commodities - Raw format without slashes
  { symbol: 'XAUUSD', name: 'Gold/USD', type: 'commodity', active: true },
  { symbol: 'XAGUSD', name: 'Silver/USD', type: 'commodity', active: true },
  { symbol: 'XPTUSD', name: 'Platinum/USD', type: 'commodity', active: true },
  { symbol: 'XPDUSD', name: 'Palladium/USD', type: 'commodity', active: true },
  { symbol: 'WTIUSD', name: 'Oil/USD', type: 'commodity', active: true },
  { symbol: 'NGUSD', name: 'Natural Gas/USD', type: 'commodity', active: true },
  { symbol: 'ALUUSD', name: 'Aluminum/USD', type: 'commodity', active: true },
  { symbol: 'COPPERUSD', name: 'Copper/USD', type: 'commodity', active: true },
  { symbol: 'ZINCUSD', name: 'Zinc/USD', type: 'commodity', active: true },
  
  // Major Stocks
  { symbol: 'AAPL', name: 'Apple Inc.', type: 'stock', active: true },
  { symbol: 'TSLA', name: 'Tesla Inc.', type: 'stock', active: true },
  { symbol: 'AMZN', name: 'Amazon.com Inc.', type: 'stock', active: true },
  { symbol: 'MSFT', name: 'Microsoft Corporation', type: 'stock', active: true },
  { symbol: 'NVDA', name: 'NVIDIA Corporation', type: 'stock', active: true },
  { symbol: 'META', name: 'Meta Platforms Inc.', type: 'stock', active: true },
  { symbol: 'NFLX', name: 'Netflix Inc.', type: 'stock', active: true },
  { symbol: 'GOOGL', name: 'Alphabet Inc.', type: 'stock', active: true },
  { symbol: 'BA', name: 'Boeing Co.', type: 'stock', active: true },
  { symbol: 'JPM', name: 'JPMorgan Chase & Co.', type: 'stock', active: true }
];

const SearchablePairSelector: React.FC<SearchablePairSelectorProps> = ({
  selectedPair,
  onPairSelect,
  tradingMode,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  // Get filtered tickers based on trading mode, search, and category
  const getFilteredTickers = useCallback(() => {
    // Use the appropriate predefined list based on trading mode
    const baseList = tradingMode === 'cfd' ? CFD_INSTRUMENTS : TOP_CRYPTO_PAIRS;
    
    // Filter by search term if provided
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      return baseList.filter(ticker => 
        ticker.symbol.toLowerCase().includes(term) ||
        ticker.name.toLowerCase().includes(term)
      );
    }
    
    return baseList;
  }, [tradingMode, searchTerm]);

  const handlePairSelect = (symbol: string) => {
    onPairSelect(symbol);
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  // Updated formatPairDisplay function to handle CFD instruments correctly
  const formatPairDisplay = (symbol: string, name?: string) => {
    if (tradingMode === 'cfd') {
      // For CFD instruments - display with slashes for UI only
      if (symbol.includes('USD') && !symbol.includes('USDT')) {
        // For forex pairs, format as XXX/YYY
        if (symbol.length === 6) {
          return `${symbol.substring(0, 3)}/${symbol.substring(3, 6)}`;
        }
        
        // For commodities, use their display names
        if (symbol === 'XAUUSD') return 'Gold/USD';
        if (symbol === 'XAGUSD') return 'Silver/USD';
        if (symbol === 'XPTUSD') return 'Platinum/USD';
        if (symbol === 'WTIUSD') return 'Oil/USD';
      }
      // Stock symbols remain as is
      return name ? `${symbol}` : symbol;
    }
    
    // For crypto pairs, format as BTC/USDT
    if (symbol.endsWith('USDT')) {
      return symbol.replace('USDT', '/USDT');
    }
    return symbol;
  };

  const getCategoryIcon = (type: 'forex' | 'commodity' | 'stock' | 'crypto' | 'index') => {
    switch (type) {
      case 'forex': return '💱';
      case 'commodity': return '🥇';
      case 'stock': return '📈';
      case 'crypto': return '₿';
      case 'index': return '📊';
      default: return '📊';
    }
  };

  const filteredTickers = getFilteredTickers();

  // Get current pair display name
  const currentPairDisplay = formatPairDisplay(selectedPair);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 hover:bg-slate-800 px-3 py-2 rounded-lg transition-colors"
      >
        <h1 className="text-2xl font-bold text-white">
          {currentPairDisplay}
          {tradingMode === 'futures' && <span className="text-sm text-slate-400 ml-2">Perp</span>}
          {tradingMode === 'cfd' && <span className="text-sm text-slate-400 ml-2">CFD</span>}
        </h1>
        <ChevronDown size={16} className="text-slate-400" />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-50 w-96 max-h-96 overflow-hidden">
          {/* Search Header */}
          <div className="p-4 border-b border-slate-700">
            <div className="relative">
              <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" />
              <input
                ref={inputRef}
                type="text"
                placeholder={`Search ${tradingMode === 'cfd' ? 'instruments' : 'pairs'}...`}
                value={searchTerm}
                onChange={handleSearchChange}
                className="w-full bg-slate-900 text-white pl-10 pr-10 py-2 rounded-xl border border-slate-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              {searchTerm && (
                <button
                  onClick={clearSearch}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-white"
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>

          {/* Results */}
          <div className="max-h-80 overflow-y-auto">
            {filteredTickers.length > 0 ? (
              <div className="p-2">
                {/* Group by type for CFD mode */}
                {tradingMode === 'cfd' && (
                  <>
                    {/* Forex Section */}
                    <div className="text-xs font-semibold text-slate-400 uppercase mt-2 mb-1 px-3">
                      Forex Pairs
                    </div>
                    {filteredTickers
                      .filter(ticker => ticker.type === 'forex')
                      .map((ticker) => (
                        <button
                          key={ticker.symbol}
                          onClick={() => handlePairSelect(ticker.symbol)}
                          className={`w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition-colors flex items-center justify-between ${
                            selectedPair === ticker.symbol ? 'bg-slate-700 text-blue-400' : 'text-white'
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <span className="text-lg">{getCategoryIcon(ticker.type)}</span>
                            <div>
                              <div className="font-medium">{formatPairDisplay(ticker.symbol, ticker.name)}</div>
                              <div className="text-xs text-slate-400 truncate max-w-48">{ticker.name}</div>
                            </div>
                          </div>
                          <span className="text-xs text-slate-500 uppercase">{ticker.type}</span>
                        </button>
                      ))}
                    
                    {/* Commodities Section */}
                    <div className="text-xs font-semibold text-slate-400 uppercase mt-4 mb-1 px-3">
                      Commodities
                    </div>
                    {filteredTickers
                      .filter(ticker => ticker.type === 'commodity')
                      .map((ticker) => (
                        <button
                          key={ticker.symbol}
                          onClick={() => handlePairSelect(ticker.symbol)}
                          className={`w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition-colors flex items-center justify-between ${
                            selectedPair === ticker.symbol ? 'bg-slate-700 text-blue-400' : 'text-white'
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <span className="text-lg">{getCategoryIcon(ticker.type)}</span>
                            <div>
                              <div className="font-medium">{formatPairDisplay(ticker.symbol, ticker.name)}</div>
                              <div className="text-xs text-slate-400 truncate max-w-48">{ticker.name}</div>
                            </div>
                          </div>
                          <span className="text-xs text-slate-500 uppercase">{ticker.type}</span>
                        </button>
                      ))}
                    
                    {/* Stocks Section */}
                    <div className="text-xs font-semibold text-slate-400 uppercase mt-4 mb-1 px-3">
                      Stocks
                    </div>
                    {filteredTickers
                      .filter(ticker => ticker.type === 'stock')
                      .map((ticker) => (
                        <button
                          key={ticker.symbol}
                          onClick={() => handlePairSelect(ticker.symbol)}
                          className={`w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition-colors flex items-center justify-between ${
                            selectedPair === ticker.symbol ? 'bg-slate-700 text-blue-400' : 'text-white'
                          }`}
                        >
                          <div className="flex items-center gap-3">
                            <span className="text-lg">{getCategoryIcon(ticker.type)}</span>
                            <div>
                              <div className="font-medium">{formatPairDisplay(ticker.symbol, ticker.name)}</div>
                              <div className="text-xs text-slate-400 truncate max-w-48">{ticker.name}</div>
                            </div>
                          </div>
                          <span className="text-xs text-slate-500 uppercase">{ticker.type}</span>
                        </button>
                      ))}
                  </>
                )}
                
                {/* Non-CFD mode - just list all pairs */}
                {tradingMode !== 'cfd' && filteredTickers.map((ticker) => (
                  <button
                    key={ticker.symbol}
                    onClick={() => handlePairSelect(ticker.symbol)}
                    className={`w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition-colors flex items-center justify-between ${
                      selectedPair === ticker.symbol ? 'bg-slate-700 text-blue-400' : 'text-white'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-lg">{getCategoryIcon(ticker.type)}</span>
                      <div>
                        <div className="font-medium">{formatPairDisplay(ticker.symbol, ticker.name)}</div>
                        <div className="text-xs text-slate-400 truncate max-w-48">{ticker.name}</div>
                      </div>
                    </div>
                    <span className="text-xs text-slate-500 uppercase">{ticker.type}</span>
                  </button>
                ))}
              </div>
            ) : (
              <div className="p-4 text-center text-slate-400">
                {searchTerm ? `No ${tradingMode === 'cfd' ? 'instruments' : 'pairs'} found` : `No ${tradingMode === 'cfd' ? 'instruments' : 'pairs'} available`}
              </div>
            )}
          </div>

          {/* Footer info */}
          <div className="p-3 border-t border-slate-700 bg-slate-900/50">
            <div className="text-xs text-slate-400 text-center">
              {filteredTickers.length} {tradingMode === 'cfd' ? 'instruments' : 'pairs'} available
              {searchTerm && ` • Filtered by "${searchTerm}"`}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchablePairSelector;